export default __webpack_public_path__ + "static/media/titleBio.08a0afbf.webp";